import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no } from 'intact-vue';
import { getRestProps } from '../utils';
import { CardColumn } from './column';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    title = _this$get.title,
    type = _this$get.type,
    size = _this$get.size;
  var k = this.config.k;
  var hasHeader = $blocks.header || $blocks.title || title || $blocks.extra;
  var hasColumn = false;
  if (children && children.length) {
    for (var i = 0; i < children.length; i++) {
      var vNode = children[i];
      if (vNode && vNode.tag === CardColumn) {
        hasColumn = true;
        break;
      }
    }
  }
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-card"] = true, _classNameObj[k + "-shadow"] = type === 'shadow', _classNameObj[k + "-border"] = type === 'border', _classNameObj[k + "-none"] = type === 'none', _classNameObj[k + "-no-header"] = !hasHeader, _classNameObj[k + "-card-grid"] = hasColumn, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [hasHeader ? _$ce(2, 'div', (_$blocks['header'] = function ($super) {
    return [_$ce(2, 'div', (_$blocks['title'] = function ($super) {
      return title;
    }, __$blocks['title'] = function ($super, data) {
      var block = $blocks['title'];
      var callBlock = function callBlock() {
        return _$blocks['title'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['title'](_$no)), 0, _$cn(k + "-card-title")), $blocks.extra ? _$ce(2, 'div', (_$blocks['extra'] = function ($super) {
      return null;
    }, __$blocks['extra'] = function ($super, data) {
      var block = $blocks['extra'];
      var callBlock = function callBlock() {
        return _$blocks['extra'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['extra'](_$no)), 0, _$cn(k + "-card-extra")) : undefined];
  }, __$blocks['header'] = function ($super, data) {
    var block = $blocks['header'];
    var callBlock = function callBlock() {
      return _$blocks['header'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['header'](_$no)), 0, _$cn(k + "-card-header c-clearfix")) : undefined, _$ce(2, 'div', children, 0, _$cn(k + "-card-body"))]);
}
;